import Vue from 'vue';
import { BASE_URL } from '@/api/const.js';

let user = JSON.parse(localStorage.getItem('user'));

export default {
    // fetching calls list
    fetchBalance() {
        return Vue.http.get(BASE_URL + 'userdata/profile/get_balance/', {
            headers: {
                Authorization: 'AlertButton ' + user.token,
            },
        });
    },
};
